import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; // Import the router
import { globalMixin } from "./mixins/globalMixin"; // Import the global mixin

// Create the app instance and inject the router
const app = createApp(App);

// Use the router in the Vue app
app.use(router);

// Register the global mixin
app.mixin(globalMixin);

// Mount the app to the DOM
app.mount("#app");

// update
